import React, { useEffect, useRef, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate, useSearchParams, useLocation } from "react-router-dom";


const SellerTopImage = () => {

     const location = useLocation();

    const params = new URLSearchParams(location.search);
    const redirectPath = params.get('redirect') || '/';

     return (
        <>
            <section className="banner-form-plain text_inter position-relative  mb-48" style={{backgroundImage:"url('/assets/images/profile_temp/bgheader.jpg')"}}>
                <div className="container h-100">
                    <div className="d-flex align-items-center justify-content-center h-100">
                        <div className="z-2 position-relative text-center">
                            <div>
                                <span className="text_quicksand text-56 text-white fw-bold lh-40">Start Selling Today!</span>
                            </div>
                            <div>
                                <span className="text_inter text-16 text-white fw-medium lh-40">More than 1000 stores from independent sellers.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
      );
    };

    export default SellerTopImage;